import ItemIcon from './ItemIcon';

export default ItemIcon;
